const toFiniteNumber = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

/** Format a displayed result without changing the stored/calculated value. */
export const formatDisplayNumber = (
  value: unknown,
  maximumFractionDigits = 2,
  fallback = '-',
): string => {
  const numeric = toFiniteNumber(value);
  if (numeric == null) return fallback;
  const digits = Math.max(0, Math.min(2, Math.trunc(maximumFractionDigits)));
  const rendered = numeric.toFixed(digits).replace(/\.?0+$/, '');
  return rendered === '-0' || rendered === '' ? '0' : rendered;
};

/** Remove binary floating-point tails without changing deliberately precise values. */
export const normalizeFloatingPointArtifacts = (text: string): string => (
  String(text || '').replace(/-?\d+\.\d{6,}/g, (token) => {
    const numeric = Number(token);
    if (!Number.isFinite(numeric)) return token;
    const rounded = Number(numeric.toFixed(2));
    const tolerance = Math.max(1, Math.abs(numeric)) * 1e-11;
    return Math.abs(numeric - rounded) <= tolerance
      ? formatDisplayNumber(numeric, 2, token)
      : token;
  })
);
